<template>
  <div id="ca-input-copiable">

    <v-text-field
      class="text-field"
      no-resize
      outlined
      filled
      readonly
      :label="label"
      :value="value"
    >
      <template slot="append">
        <v-icon @click="copiarContenido()">content_copy</v-icon>
      </template>
    </v-text-field>

  </div>
</template>

<script>
import { LAYOUT_MUTATION_SNACKBAR_EXITO, LAYOUT_MUTATION_SNACKBAR_ERROR } from '@/store/layout/layout.types';

export default {
  name: 'CaInputCopiable',

  props:{
    value: { type: String, default: '' },
    label: { type: String, default: '' }
  },

  /**
   * Metodo para copiar el contenido del input
   */
  methods:{
    copiarContenido(){
      navigator.clipboard.writeText(this.value).then(() => {
        this.$store.commit(LAYOUT_MUTATION_SNACKBAR_EXITO, '¡Texto copiado!');
      }, (err) => {
        this.$store.commit(LAYOUT_MUTATION_SNACKBAR_ERROR, err);
      });
    },
  }

};
</script>

<style lang="scss">
#ca-input-copiable{

	.text-field{
    border-radius: 4px;

    input{
      margin: 0;
      color: color(gris-oscuro);
      font-family: Roboto Mono, monospace;
    }
  }

  .v-text-field__details {
    display: none;
  }
}
</style>